// extracted by mini-css-extract-plugin
export default {"tableWrapper":"ProvidersPage_tableWrapper__w0Ywn","oddRow":"ProvidersPage_oddRow__5gPDW"};